import React, { ReactElement, ReactText } from 'react'
import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify'
import colors from '../lib/colors'
import theme from '../lib/theme'
import 'react-toastify/dist/ReactToastify.css'

export const alertError = (text: string): ReactText => toast.error(text)
export const alertInfo = (text: string): ReactText => toast.info(text)
export const alertSuccess = (text: string): ReactText => toast.success(text)
export const alertMessage = (text: string): ReactText => toast.info(text, { className: 'neutral' })

export type NotificationsProps = {
  closeAfterSeconds?: number
  notificationPosition?: NotificationPosition
}

export enum NotificationPosition {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  TopCenter = 'top-center',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
  BottomCenter = 'bottom-center',
}

const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast-body {
    font-family: ${theme.fontFamily};
  }
  .Toastify__toast--error {
    background: ${colors.red};
  }
  .Toastify__toast--info {
    background: ${colors.blue};
  }
  .Toastify__toast--success {
    background: ${colors.green};
  }
  .neutral {
    background: ${colors.lightestGray};
    color: ${colors.darkestGray};
    .Toastify__progress-bar--info {
      background: ${colors.gray};
    }
  }
`

function Notifications(props: NotificationsProps): ReactElement {
  const {
    closeAfterSeconds = 5,
    notificationPosition = NotificationPosition.BottomRight,
  } = props

  return (
    <StyledToastContainer
      theme="colored"
      position={notificationPosition}
      autoClose={closeAfterSeconds * 1000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={true}
      rtl={false}
      pauseOnFocusLoss={true}
      draggable={false}
      pauseOnHover={true}
    />
  )
}

export default Notifications
